import { Eye } from 'lucide-react';
import { ProfessionalCard } from '@/components/session/components/ProfessionalCard';
import { ProfessionalShowcasePanel } from '@/components/professional/ProfessionalShowcasePanel';

/** Monta os dados públicos do card a partir do perfil completo do profissional. */
export const toPublicCardData = (
	professional: Professionals.Professional,
): Professionals.PublicCardData => ({
	id: professional.id,
	first_name: professional.first_name,
	last_name: professional.last_name,
	name_prefix: professional.name_prefix ?? null,
	crm_or_crp: professional.crm_or_crp,
	profile_photo_url: professional.profile_photo_url ?? null,
	brief_description: professional.brief_description ?? null,
	video_url: professional.video_url ?? null,
	highlight_tag: professional.highlight_tag ?? null,
	main_approach: professional.main_approach ?? null,
	secondary_approaches: professional.secondary_approaches ?? [],
	focus_topics: professional.focus_topics ?? [],
	service_modality: professional.service_modality,
});

const noop = () => {};

/**
 * Pré-visualização "como o público vê": o card compacto usado no agendamento
 * lado a lado com o painel "Conheça o profissional".
 */
const ProfessionalPublicPreview = ({
	professional,
}: {
	professional: Professionals.Professional;
}) => {
	const publicData = toPublicCardData(professional);
	const service = professional.professional_services?.[0]?.service;
	const serviceName =
		service?.service_name ?? service?.professional_label ?? undefined;

	return (
		<div className="space-y-4">
			<div className="flex items-center gap-2 rounded-xl border border-sky-100 bg-sky-50 px-4 py-3 text-left text-xs font-semibold text-sky-800">
				<Eye size={16} className="shrink-0" />
				<span>
					Esta é uma pré-visualização. Os botões não agendam nada. As
					alterações aparecem aqui depois de salvas.
				</span>
			</div>

			<div className="flex flex-col gap-6">
				<section className="space-y-2">
					<h3 className="ml-1 text-[9px] font-black uppercase tracking-widest text-stone-400">
						Card na lista de profissionais
					</h3>
					<div className="pointer-events-auto">
						<ProfessionalCard
							professional_id={publicData.id}
							video_url={publicData.video_url}
							profile_photo_url={publicData.profile_photo_url}
							name_prefix={publicData.name_prefix}
							first_name={publicData.first_name}
							last_name={publicData.last_name}
							crm_or_crp={publicData.crm_or_crp}
							service_name={serviceName}
							brief_description={publicData.brief_description}
							highlight_tag={publicData.highlight_tag}
							main_approach={publicData.main_approach}
							secondary_approaches={
								publicData.secondary_approaches
							}
							focus_topics={publicData.focus_topics}
							onClick={noop}
							isSelected={false}
							selectedButtonText="Agendar"
						/>
					</div>
				</section>

				<section className="space-y-2">
					<h3 className="ml-1 text-[9px] font-black uppercase tracking-widest text-stone-400">
						Painel "Conheça o profissional"
					</h3>
					<div className="overflow-hidden rounded-[2rem] border border-stone-100 bg-white shadow-sm">
						<ProfessionalShowcasePanel
							professional={publicData}
							serviceName={serviceName}
							previewMode
						/>
					</div>
				</section>
			</div>
		</div>
	);
};

export { ProfessionalPublicPreview };
